module.exports = __webpack_public_path__ + "static/media/KR-en.13bf4a2d.png";